import { Box, Button, Card, Typography } from "@mui/material";
import { executeGameAction } from "api/game/gameActions";
import { ChooseAttackOptionType } from "models/ChooseAttackOptionType";
import { useSnackbar } from "notistack";
import React from "react";
import { useParams } from "react-router-dom";
import { playerColorToBackgroundHex, playerColorToHex } from "utils/styling_helpers";

export interface Props {
  options: ChooseAttackOptionType[];
}

export const Component: React.FC<Props> = ({ options }) => {
  const { gameId } = useParams();
  const { enqueueSnackbar } = useSnackbar();

  const onClick = (target: string) => {
    if (gameId === undefined) {
      console.error("Game ID is undefined");
      return;
    }
    executeGameAction({
      gameId,
      ActionData: {
        target,
      },
      ActionId: "ATTACK",
      DecisionId: "CHOOSE_ATTACK_TARGET",
      enqueueSnackbar,
    });
  };

  return (
    <Card
      sx={{
        borderRadius: 0,
      }}
    >
      <Typography variant="h5">Choose Attack Target:</Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {options.map((option) => (
          <Button
            onClick={() => onClick(option.option)}
            sx={{
              backgroundColor: playerColorToHex(option.color),
              m: 1,
              color: "white",
              "&:hover": {
                backgroundColor: playerColorToBackgroundHex(option.color),
              },
            }}
          >
            {option.description}
          </Button>
        ))}
      </Box>
    </Card>
  );
};

Component.displayName = "ChooseAttackTarget";
